import Vue from 'vue'
import Buefy from 'buefy'

import CustomPageDisplay from './App.vue';

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(CustomPageDisplay)

if(document.getElementById("customPageDisplay")){
    new Vue({
        render:h=>h(
            CustomPageDisplay,{
                props:{
                    detailUrl:document.getElementById("customPageDisplay")
                        .getAttribute("detailUrl"),
                    
                }
            }
        )
    }).$mount("#customPageDisplay")
}